module.exports = __webpack_public_path__ + "img/bmw.57203429.png";